import { createElement } from 'react';

export const ConditionalButton = ({
  children,
  fallback = 'div',
  className,
  onClick,
}: {
  children: React.ReactNode;
  fallback?: React.ElementType;
  className?: string;
  onClick?: () => void;
}) => {
  if (!onClick) return createElement(fallback, { className }, children);

  return (
    <button className={className} onClick={onClick}>
      {children}
    </button>
  );
};
